module.exports = __webpack_public_path__ + "img/ExpertViewBannerforExpertBuzz(1).19ff7289.svg";